import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { getBoardIdFromURL, getCurrentUserId } from "./util/common";

// disable on locql to save
if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1"
) {
  try {
    // unique link to my app on logRocket
    LogRocket.init("hm7p7j/swift");

    setupLogRocketReact(LogRocket);

    // identify current user id
    LogRocket.identify(getCurrentUserId(), {
      board: getBoardIdFromURL(),
      time: Date.now,
    });
  } catch(e){
    console.error("logging init failed");
  }
 
}
